// extracted by mini-css-extract-plugin
export var BackToTop = "backToTop-module--BackToTop--4246f";
export var slideIn = "backToTop-module--slide-in--02d18";
export var slideInFromRight = "backToTop-module--slide-in-from-right--fa5b7";